import has from 'ramda/src/has'
import pipe from 'ramda/src/pipe'
import reject from 'ramda/src/reject'
import isNil from 'ramda/src/isNil'
import compose from 'ramda/src/compose'
import map from 'ramda/src/map'
import addIndex from 'ramda/src/addIndex'
import { moduleIdProp } from 'root/src/client/logic/route/lenses'
import { formModuleLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { prop } from 'root/src/shared/util/nativeFns'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'
import formDataSelector from 'root/src/client/logic/form/selectors/formData'
import validateForm from 'root/src/client/logic/form/util/validateForm'
import is from 'ramda/src/is'

const { viewOnInputFn } = formModuleLenses

// important - to use functions with onExit, these need to have multiple invocations
// prevented. check example in src/client/logic/dropEvent/thunks/saveDropEvent.js
const onExitHandler = (props, fieldOnExit) => {
	const { moduleKey } = props
	const moduleId = moduleIdFromKey(moduleKey)
	const onInputFn = viewOnInputFn(moduleId, moduleDescriptions)

	if (!fieldOnExit && !onInputFn) return undefined

	return (dispatch, getState) => {
		const currentState = getState()
		return validateForm(moduleKey, currentState).then(async () => {
			const formData = formDataSelector(currentState, props)

			return Promise.all(pipe(
				reject(isNil),
				map(fn => dispatch(fn(formData, props))),
			)([onInputFn, fieldOnExit]))
		})
	}
}

const getFieldProps = (state, props, field, fieldIndex, subFieldIndex) => {
	const fieldMod = typeof field === 'function' ? field(state, props) : field
	const {
		fieldId,
		inputType,
		subFieldText,
		labelFieldText,
		fieldStorePath,
		extraButton,
		inputMaxLength,
		subTextLabel,
		fieldFullWidth,
		fieldActionButton,
		fieldHalfWidth,
		variantOptions,
		optionsPromiseType,
		locked,
		fieldOnExit,
		default: fieldDefault,
		breakpointItems,
		options,
		crop,
		over,
		hideInput,
		isMultiGame,
		customFieldProps,
		asyncOptionsStoreKey,
		clearFormInputs,
		column,
		fieldToggle,
	} = fieldMod
	const onExitFn = onExitHandler(props, fieldOnExit)

	return [
		[fieldId],
		[...(has('stepId', props) ? ['steps', props.stepId] : []), 'fields', fieldIndex, ...(!isNil(subFieldIndex) ? [subFieldIndex] : [])],
		inputType,
		fieldId,
		subFieldText
			? typeof subFieldText === 'string' || Array.isArray(subFieldText)
				? subFieldText
				: subFieldText(state, props)
			: undefined,
		labelFieldText,
		extraButton,
		inputMaxLength,
		subTextLabel,
		fieldFullWidth,
		fieldActionButton,
		fieldHalfWidth,
		fieldStorePath,
		variantOptions,
		optionsPromiseType,
		locked,
		options ? options[0] : fieldDefault,
		onExitFn,
		breakpointItems,
		crop,
		over,
		hideInput ? hideInput(state, props) : undefined,
		isMultiGame,
		customFieldProps,
		fieldToggle,
		asyncOptionsStoreKey,
		clearFormInputs,
		column,
	]
}

export default (state, props) => compose(
	addIndex(map)(
		(field, fieldIndex) => {
			if (is(Array, field)) {
				return addIndex(map)(
					(field0, fieldIndex0) => getFieldProps(
						state,
						props,
						field0,
						fieldIndex,
						fieldIndex0,
					),
					field,
				)
			}
			return getFieldProps(state, props, field, fieldIndex)
		},
	),
	(moduleId) => {
		const { stepFormCurrentPage } = props
		if (stepFormCurrentPage) {
			return prop('fields', stepFormCurrentPage)
		}
		return formModuleLenses.viewFields(
			moduleId, moduleDescriptions,
		) || []
	},
	moduleIdProp,
)(props)
